import axiosInstance from '@/utils/httpUtil'
import { setting } from '@/setting'

const adminBaseUrl = setting.adminBaseUrl

export const interviewApi = {
  // 获取面经列表
  getInterviewExperiences: (page, pageSize) => {
    return axiosInstance.get(
      `${adminBaseUrl}/interviewExperiences?page=${page}&pageSize=${pageSize}`
    )
  },

  // 创建面经
  createInterviewExperience: (data) => {
    return axiosInstance.post(
      `${adminBaseUrl}/interviewExperience`,
      {
        companyName: data.companyName,
        jobTitle: data.jobTitle,
        experienceDetail: data.experienceDetail
      }
    )
  },

  // 更新面经
  updateInterviewExperience: (expId, data) => {
    return axiosInstance.put(
      `${adminBaseUrl}/interviewExperience/${expId}`,
      {
        companyName: data.companyName,
        jobTitle: data.jobTitle,
        experienceDetail: data.experienceDetail
      }
    )
  },

  // 删除面经
  deleteInterviewExperience: (expId) => {
    return axiosInstance.delete(
      `${adminBaseUrl}/interviewExperience/${expId}`
    )
  }
} 